<h4 class="h4 chart-title chart-title--thin margin-none padding-top_half">
  {{ 'groups.dashboard.averageProgress' | translate }}
  <gl-tooltip posBottom [text]="tooltipText"></gl-tooltip>
</h4>
<div class="progress-range">
  <lms-range [config]="rangeConfig"></lms-range>
</div>
